module.exports = __webpack_public_path__ + "static/media/November_2026_4.297c2b40.webp";